/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_theme_toggle = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toggle theme`)
};

const zh_hans1_theme_toggle = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`切换主题`)
};

const zh_hant1_theme_toggle = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`切換主題`)
};

const fr_theme_toggle = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Basculer le thème`)
};

const de_theme_toggle = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Theme umschalten`)
};

const ja_theme_toggle = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テーマを切り替え`)
};

const ko_theme_toggle = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`테마 전환`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const theme_toggle = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.theme_toggle(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("theme_toggle", locale)
	if (locale === "en") return en_theme_toggle(inputs)
	if (locale === "zh-Hans") return zh_hans1_theme_toggle(inputs)
	if (locale === "zh-Hant") return zh_hant1_theme_toggle(inputs)
	if (locale === "fr") return fr_theme_toggle(inputs)
	if (locale === "de") return de_theme_toggle(inputs)
	if (locale === "ja") return ja_theme_toggle(inputs)
	return ko_theme_toggle(inputs)
};